function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st12{display:inline;}\r\n\t\t.st11{fill:#231F20;}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "drop"
}, /*#__PURE__*/React.createElement("g", {
  className: "st12"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M50,100C22.4,100,0,77.6,0,50C0,22.4,22.4,0,50,0s50,22.4,50,50C100,77.6,77.6,100,50,100z M50,3.3 C24.3,3.3,3.3,24.3,3.3,50S24.3,96.7,50,96.7S96.7,75.7,96.7,50S75.7,3.3,50,3.3z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M73.5,35.2c0-2.7-2.2-4.8-4.8-4.8H57.3c0-0.3,0-0.6,0-0.6c0-2.5-2-4.6-4.6-4.6h-5.6c-2.5,0-4.6,2-4.6,4.6 c0,0,0,0.2,0,0.6H31.3c-2.7,0-4.8,2.2-4.8,4.8c0,2.5,1.8,4.5,4.2,4.8v26.3c0,4.4,3.5,7.9,7.9,7.9h22.8c4.4,0,7.9-3.5,7.9-7.9V40 C71.7,39.7,73.5,37.7,73.5,35.2z M47.2,28.1h5.6c0.9,0,1.7,0.8,1.7,1.7c0,0.1,0,0.2,0,0.3h-9c0-0.1,0-0.2,0-0.3 C45.5,28.9,46.2,28.1,47.2,28.1z M66.5,66.3c0,2.8-2.3,5-5,5H38.6c-2.8,0-5-2.3-5-5V40h32.9V66.3z M68.7,37.2h-0.8H32.1h-0.8 c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2h37.4c1.1,0,2,0.9,2,2C70.7,36.3,69.8,37.2,68.7,37.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M40.6,63.5c0.8,0,1.4-0.6,1.4-1.2V47.7c0-0.7-0.6-1.2-1.4-1.2c-0.8,0-1.4,0.6-1.4,1.2v14.6 C39.2,63,39.8,63.5,40.6,63.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M50,64.9c0.8,0,1.4-0.6,1.4-1.4V46.5c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4v16.9 C48.5,64.2,49.2,64.9,50,64.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M59.3,63.5c0.8,0,1.4-0.6,1.4-1.2V47.7c0-0.7-0.6-1.2-1.4-1.2c-0.8,0-1.4,0.6-1.4,1.2v14.6 C57.9,63,58.6,63.5,59.3,63.5z"
})))));

var SvgDrop = function SvgDrop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drop.a16f0bb1.svg";
export { ForwardRef as ReactComponent };